var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTotalAvailableRollback = function SvgTotalAvailableRollback(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 48,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd0d7",
    fillRule: "evenodd",
    d: "M24.6465 5.46013H11.747c-.5523 0-1 .44771-1 1v3c0 .55227.4477.99997 1 .99997h12.8995c.3978 0 .7794.1581 1.0607.4394l40.2947 40.2946 3.5355-3.5355L29.2427 7.36393c-1.219-1.21898-2.8723-1.9038-4.5962-1.9038",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "M67.4161 49.78 27.1214 9.48529c-.6564-.65638-1.5466-1.02513-2.4749-1.02513h-13.898l-.0014.20719-.0001.79281c0 .55224.4477 1.00004 1 1.00004h12.8995c.3978 0 .7794.158 1.0607.4393l40.2947 40.2947z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "M36.9098 12.2028c-.781-.7811-2.0474-.7811-2.8284 0l-3.6569 3.6568c-.375.3751-.5857.8838-.5857 1.4143v12.4852c0 .5305.2107 1.0392.5857 1.4143l9.3137 9.3137c1.5621 1.5621 4.0948 1.5621 5.6569 0l8.4853-8.4853c.781-.7811.781-2.0474 0-2.8284z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M35.4958 13.617c-.7811-.7811-2.0474-.7811-2.8285 0l-3.0547 3.0547c-.7598.7598-1.182 1.7933-1.1714 2.8678l.0799 8.1126c.0103 1.0471.4309 2.0485 1.1714 2.789L39.7384 40.487c1.5621 1.5621 4.0948 1.5621 5.6569 0l7.071-7.071c.7811-.7811.7811-2.0474 0-2.8285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "M40.4455 25.6378c-.7811-.781-2.0474-.781-2.8285 0l-3.5355 3.5356c-.781.781-.781 2.0474 0 2.8284l7.0711 7.0711c.781.781 2.0473.781 2.8284 0l4.2426-4.2427c.3906-.3905.3906-1.0237 0-1.4142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.4455 25.6378c-.7811-.781-2.0474-.781-2.8285 0l-3.5355 3.5356 8.4853 8.4853c.781.781 2.0474.781 2.8284 0l3.5355-3.5356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "M38.3241 10.7886c-.781-.781-2.0474-.781-2.8284 0l-1.4142 1.4142c-.7811.7811-.7811 2.0474 0 2.8284l7.0711 7.0711c.781.7811 2.0473.7811 2.8284 0l1.4142-1.4142c.781-.7811.781-2.0474 0-2.8284z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#df0024",
    strokeWidth: 2,
    d: "m46.6326 37.4818-7.0156-7.0156c-.3751-.3751-.8838-.5858-1.4143-.5858h-5.5355"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "m51.759 34.1232-1.4142 1.4142 15.6569 15.6568 1.4142-1.4142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff677f",
    d: "m53.8804 32.0018-2.1213 2.1214L67.4159 49.78l2.1213-2.1213z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v48H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTotalAvailableRollback);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "total-available-rollback.cb4afacf66593c2ad9322ec8a925087e.svg";